import React from 'react';

function MultipleOpenViewMode(props) {
    const buildOpenTextChoicesContainer = () => {
        const questionId = props.questionData.id;
        const selects = props.questionData.selects;

        return selects.map((select, index) => {
            const uniqueKey = "question_" + questionId + "_open_select_" + index;
            return (
                <div key={uniqueKey} className="questionaire__builder__question__form__row" align={"right"}>
                    <div className="questionaire__builder__question__form__cell">{select.label}</div>
                    <input type="text" className="questionaire__builder__question__form__input"/>
                </div>
            )
        });
    };

    return (
        <div
            className="questionaire__builder__question__form multiple_open_viewmode questionaire__builder__question__form--table questionaire__builder__question__form--withPadding">
            {buildOpenTextChoicesContainer()}
        </div>
    );
}

export default MultipleOpenViewMode;
